import React from 'react';
import { useState, useEffect } from 'react';
import VideoCard from './VideoCard';



const VideoGallery = () => {
  // Obtener categoría de la URL si existe
  const getInitialCategory = () => {
    const params = new URLSearchParams(window.location.search);
    const categoria = params.get('categoria');
    return categoria && ['llengueta', 'tiny_tongue'].includes(categoria) ? categoria : 'llengueta';
  };

  const hasUrlParameter = () => {
    const params = new URLSearchParams(window.location.search);
    return params.has('categoria');
  };

  const [filter, setFilter] = useState(getInitialCategory());
  const [videos, setVideos] = useState([]);
  const [voteCounts, setVoteCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const showFilters = !hasUrlParameter();
  const [isVotingActive, setIsVotingActive] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        // Obtener estado de las votaciones
        const statusResponse = await fetch('https://votacions.apuntsdellengua.es/api/');
        if (statusResponse.ok) {
          const statusResult = await statusResponse.json();
          setIsVotingActive(!statusResult.voting_closed);
        }
        
        // Obtener videos
        const videosResponse = await fetch('https://votacions.apuntsdellengua.es/api/recompte');
        if (!videosResponse.ok) {
          throw new Error('Error al obtener los videos');
        }
        const videosResult = await videosResponse.json();
        
        // Obtener recuentos de votos por categoría
        const countsResponse = await fetch('https://votacions.apuntsdellengua.es/api/recompte-categories');
        if (!countsResponse.ok) {
          throw new Error('Error al obtener los recuentos');
        }
        const countsResult = await countsResponse.json();
        
        // Mapear los campos de la API a la estructura esperada
        const videosData = videosResult.data.map(video => ({
          id: video.id_contingut,
          title: video.nom_video,
          author: video.professor || video.centre_educatiu,
          category: video.categoria,
          url: video.url_video,
          url_imatge: video.url_imatge,
          vots: video.vots || 0,
          votingPage: video.url_apunts
        }));
        
        // Normalizar las claves de categorías
        const normalizedCounts = {};
        Object.entries(countsResult.data).forEach(([key, value]) => {
          normalizedCounts[key] = value;
        });
        
        setVideos(videosData);
        setVoteCounts(normalizedCounts);
        setError(null);
      } catch (err) {
        setError(err.message);
        setVideos([]);
        setVoteCounts({});
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredVideos =
    videos.filter(v => v.category === filter);
  return (
    
    <div className="min-h-screen pb-14 px-2 bg-white">
      {showFilters && (
        <div className="flex gap-3 mb-6">
          <button
            onClick={() => setFilter('llengueta')}
            className={`px-4 py-2 rounded text-white font-semibold ${
              filter === 'llengueta' ? 'text-white' : 'bg-gray-200 text-gray-700'
            }`}
            style={{ backgroundColor: filter === 'llengueta' ? '#662d91' : undefined }}
          >
            Llengüetes
          </button>

          <button
            onClick={() => setFilter('tiny_tongue')}
            className={`px-4 py-2 rounded text-white font-semibold ${
              filter === 'tiny_tongue' ? 'text-white' : 'bg-gray-200 text-gray-700'
            }`}
            style={{ backgroundColor: filter === 'tiny_tongue' ? '#662d91' : undefined }}
          >
            Tiny Tongues
          </button>
        </div>
      )}

      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
        </div>
        


        {/* Grid de vídeos */}
        {loading && <p className="text-center text-gray-600">Carregant vídeos...</p>}
        {error && <p className="text-center text-red-600">Error: {error}</p>}
        {!loading && !error && filteredVideos.length === 0 && <p className="text-center text-gray-600">No hi ha vídeos disponibles</p>}
        
        {!loading && !error && filteredVideos.length > 0 && (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {filteredVideos.map((video) => (
              <VideoCard key={video.id} video={video} voteCounts={voteCounts} isVotingActive={isVotingActive} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoGallery;
